import { FC, HTMLAttributes } from 'react';

type SubWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const SubWallet: FC<SubWalletProps> = ({ size = 16, ...props }) => {
  const ratio = 66 / 100;
  const width = size;
  const height = size * ratio;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 66 100"
      {...props}
    >
      <path
        fill="url(#subwallet_gradient_a)"
        d="M66 36.1V22.2L11 0 0 5.6v43.1l41.8 16.7-22.2 9.5v-7.3L9.4 63.4 0 67.8v26.4l11 5.6 55-25V57L16.8 37.1V24.9l39.6 15.9z"
      ></path>
      <defs>
        <linearGradient
          id="subwallet_gradient_a"
          x1="0"
          x2="90.967"
          y1="0"
          y2="59.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#61FEC0"></stop>
          <stop offset="0.92" stopColor="#0425FE"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SubWallet;
